import { Controller } from 'stimulus'

/**
 * @namespace LinkedItemsFilter
 * {@link https://adamsilver.io/blog/building-an-accessible-autocomplete-control/}
 */
export default class extends Controller {
  /**
   * De-select all of the options in one go
   */
  deselectAll() {
    this.typeaheadMultiselectController.deselectAll()
  }

  get typeaheadMultiselectController() {
    return this.application.getControllerForElementAndIdentifier(this.element.querySelector('.organism-typeahead-multiselect'), 'atomic--organism--typeahead-multiselect--component')
  }
}
